import script from "./DEList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DEList.vue?vue&type=script&setup=true&lang=ts"

import "./DEList.vue?vue&type=style&index=0&id=4464088d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4464088d"]])

export default __exports__